import { Box } from "@mui/material";
import logoATEM from "../../assets/logo-atem.png";
import "./animate.css";

const DashLoading: React.FC = () => {
  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      height={"100vh"}
    >
      <div className={"pulse"}>
        <img src={logoATEM} width={70} height={48} alt="logo atem" />
      </div>
    </Box>
  );
};

export default DashLoading;
